/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import {
  ScheduleComponent,
  ViewsDirective,
  ViewDirective,
  Day,
  Week,
  WorkWeek,
  Month,
  Agenda,
  Inject,
  Resize,
  DragAndDrop,
  ExcelExport,
  ICalendarExport,
} from '@syncfusion/ej2-react-schedule';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

import { Header } from '.';
import { Methods } from '../pages/Methods';
import '../pages/Zackat.css';

// eslint-disable-next-line react/destructuring-assignment
const PropertyPane = (props) => <div className="mt-5">{props.children}</div>;

const AssociateCal = ({ props }) => {
  const [scheduleObj, setScheduleObj] = useState();
  const { REACT_APP_API_ENDPOINT } = process.env;
  const associateid = props._id;

  const change = (args) => {
    scheduleObj.selectedDate = args.value;
    scheduleObj.dataBind();
  };
  const handleExport = () => {
    const exportValues = {
      fileName: `${props.name}_Schedule`, // Do not include the .xlsx extension
    };

    scheduleObj.exportToExcel(exportValues); // Requires ExcelExport service
  };
  const handleExportICal = () => {
    // Pass a custom name for the .ics file
    scheduleObj.exportToICalendar(`${props.name}_Schedule`);
  };
  const onDragStart = (arg) => {
    // eslint-disable-next-line no-param-reassign
    arg.navigation.enable = true;
  };
  const { loading, data } = Methods('calendar_events', 'GET', associateid) || {};
  const usr = JSON.parse(localStorage.getItem('user'));
  if (loading) {
    return <p>Loading... </p>;
  }
  const onRendercell = (args) => {
    (args.element).style.background = args.data.CategoryColor;
  };

  const actionComplete = (args) => {
    let editedData;
    const selectedOrg = JSON.parse(localStorage.getItem('organization'));
    if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
      /** Add Validation Rules */
    }
    /** Set initial Focus */
    if (args.requestType === 'eventCreated' && args.addedRecords.length > 0) {
      editedData = args.addedRecords;
      editedData[0].organizationid = selectedOrg.id;
      editedData[0].associateid = associateid;
      // The default edit operation is cancelled
      // Here you can send the updated data to your server using AJAX call
      fetch(`${REACT_APP_API_ENDPOINT}/calendar_events`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(editedData),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson && responseJson._id) {
            for (let i = 0; i < args.addedRecords.length; i += 1) {
              if (responseJson[i] && responseJson[i]._id) {
                args.addedRecords[i]._id = responseJson[i]._id;
              }
            }
          }
          // window.location.reload();
          // The added/edited data will be saved in the Grid
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (args.requestType === 'eventChanged' && args.changedRecords.length > 0) {
      editedData = args.changedRecords;
      // The default edit operation is cancelled
      // Here you can send the updated data to your server using AJAX call
      editedData[0].organizationid = selectedOrg.id;
      editedData[0].associateid = associateid;

      fetch(`${REACT_APP_API_ENDPOINT}/calendar_events`, {
        method: 'UPDATE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(editedData),

      })
        .then((response) => response.json())
        .then(() => {
          // The added/edited data will be saved in the Grid
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (args.requestType === 'eventRemoved' && args.deletedRecords.length > 0) {
      editedData = args.deletedRecords;
      // The default edit operation is cancelled
      // Here you can send the updated data to your server using AJAX call
      fetch(`${REACT_APP_API_ENDPOINT}/calendar_events`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(editedData),

      })
        .then((response) => response.json())
        .then(() => {
          // The added/edited data will be saved in the Grid
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  let crudUpdate = false;
  let crudCreate = false;
  let crudDelete = false;
  if (data.role.calendar.permissions.includes('Create')) {
    crudCreate = true;
  }
  if (data.role.calendar.permissions.includes('Update')) {
    crudUpdate = true;
  }
  if (data.role.calendar.permissions.includes('Delete')) {
    crudDelete = true;
  }
  let crudReadOnly = false;
  if (!crudCreate && !crudDelete && !crudUpdate) {
    crudReadOnly = true;
  }
  if (!data.role.calendar.permissions.includes('Read')) {
    return <p>Not authorized...</p>;
  }
  function onPopUp(args) {
    if (args.type === 'QuickInfo') {
      const dialogObj = args.element.ej2_instances[0];
      if (crudUpdate === false) {
        dialogObj.hide();
      }
      //      var currentAction = args.target.classList.contains('e-work-cells') ? 'Add' : 'Save'
      //      scheduleObj.openEditor(args.data, currentAction)
    }
  }

  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <Header category="App" title="Associate Schedule" />
      <ButtonComponent id="xls" cssClass="e-icons e-export-excel" onClick={handleExport}>XLS</ButtonComponent>
      <ButtonComponent id="ics" cssClass="e-icons e-export" onClick={handleExportICal}>ICS</ButtonComponent>
      <ScheduleComponent
        ref={(schedule) => setScheduleObj(schedule)}
        cssClass="custom-schedule"
        selectedDate={new Date()}
        eventSettings={{ dataSource: data.calendar }}
        eventRendered={onRendercell}
        currentView="Agenda"
        readOnly={crudReadOnly}
        timeScale={{ enable: true, interval: 30, slotCount: 1 }} // 30 minute slots
        popupOpen={() => onPopUp}
        dragStart={onDragStart}
        actionComplete={actionComplete}
      >
        <ViewsDirective>
          {['Day', 'Week', 'WorkWeek', 'Month', 'Agenda'].map((item) => (
            <ViewDirective
              key={item}
              option={item}
            />
          ))}
        </ViewsDirective>
        <Inject services={[Day, Week, WorkWeek, Month, Agenda, Resize, DragAndDrop, ExcelExport, ICalendarExport]} />
      </ScheduleComponent>
      <PropertyPane>
        <table
          style={{ width: '100%', background: 'white' }}
        >
          <tbody>
            <tr style={{ height: '50px' }}>
              <td style={{ width: '100%' }}>
                <DatePickerComponent
                  value={new Date()}
                  showClearButton={false}
                  placeholder="Current Date"
                  floatLabelType="Always"
                  change={change}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </PropertyPane>
    </div>
  );
};

export default AssociateCal;
